$('#services-directory-search').on('input', function () {
    var useStartsWith = false; // Change to true for "starts with" instead of "contains"
    var searchTerm = $(this).val().trim().toLowerCase();

    // Loop through all alphabet letter groups (A, B, C, ...)
    $('.services-directory-alphabet-letter-section-container').each(function () {
        var $section = $(this);
        var $links = $section.find('.services-directory-alphabet-letter-link-list-link');
        var matchesFound = false;

        // Check each service link inside the group
        $links.each(function () {
            var $link = $(this);
            var linkText = $link.text().trim().toLowerCase();

            var isMatch = useStartsWith
                ? linkText.startsWith(searchTerm)
                : linkText.includes(searchTerm);

            if (isMatch) {
                // Show matching link container
                $link.closest('.services-directory-alphabet-letter-link-list-link-container').show();
                matchesFound = true;
            } else {
                // Hide non-matching link
                $link.closest('.services-directory-alphabet-letter-link-list-link-container').hide();
            }
        });

        // Hide entire group if no matches in it
        if (matchesFound || searchTerm === '') {
            $section.show();
        } else {
            $section.hide();
        }
    });

    // After filtering: update which letters are clickable
    if (typeof updateDisabledLetters === 'function') {
        updateDisabledLetters();
    }

    // After filtering: re-run logic to highlight the correct visible letter
    if (typeof updateActiveLetter === 'function') {
        updateActiveLetter();
    }

    // After all filtering is complete
    var $visibleSections = $('.services-directory-alphabet-letter-section-container').filter(':visible').not('.services-directory-alphabet-letter-section-no-results-container');

    if ($visibleSections.length === 0) {
        $('.services-directory-alphabet-letter-section-no-results-container').show();
    } else {
        $('.services-directory-alphabet-letter-section-no-results-container').hide();
    }
});

let isStickyActive = false;
const releaseOffset = 120;     // controls how early sticky nav releases
const hysteresisGap = 16;      // prevents flickering near the threshold

function handleStickyLogic() {
    if (window.matchMedia('(min-width: 992px)').matches) {
        const $header = $('.header-sticky-container');
        const $top = $('.services-directory-top-container');
        const $container = $('.services-directory');

        if ($header.length && $top.length && $container.length) {
            const topRect = $top[0].getBoundingClientRect();
            const containerRect = $container[0].getBoundingClientRect();
            const stickyHeight = $top.outerHeight();

            const containerBottom = containerRect.bottom;
            const triggerDistance = stickyHeight + releaseOffset;

            // ENTER sticky state only if clearly inside range
            if (!isStickyActive) {
                const shouldActivate =
                    topRect.top <= 0 &&
                    containerBottom > triggerDistance + hysteresisGap;

                if (shouldActivate) {
                    $top.addClass('sticky');
                    $header.addClass('hide-when-services-sticky');
                    isStickyActive = true;
                }
            } else {
                // EXIT sticky state only if clearly past range
                const shouldDeactivate =
                    topRect.top > 0 || containerBottom <= triggerDistance - hysteresisGap;

                if (shouldDeactivate) {
                    $top.removeClass('sticky');
                    $header.removeClass('hide-when-services-sticky');
                    isStickyActive = false;
                }
            }
        }
    } else {
        // Reset for smaller breakpoints
        $('.services-directory-top-container').removeClass('sticky');
        $('.header-sticky-container').removeClass('hide-when-services-sticky');
        isStickyActive = false;
    }
}

const throttledStickyLogic = throttle(handleStickyLogic, 100);
$(window).on('scroll resize', throttledStickyLogic);
$(document).ready(() => throttledStickyLogic());
